export const cardConfig = {
  small: {
    rounded: "rounded-lg",
    padding: "p-4",
    shadow: "shadow-md",
  },
  medium: {
    rounded: "rounded-2xl",
    padding: "p-6",
    shadow: "shadow-lg",
  },
  large: {
    rounded: "rounded-3xl",
    padding: "p-8",
    shadow: "shadow-xl",
  },
};
